export const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3001/api"

export const API_ENDPOINTS = {
  // Auth endpoints
  auth: {
    register: "/auth/register",
    login: "/auth/login",
    logout: "/auth/logout",
    validate: "/auth/validate",
    forgotPassword: "/auth/forgot-password",
    resetPassword: "/auth/reset-password",
    verifyResetToken: "/auth/verify-reset-token",
  },

  // Agent endpoints
  agent: {
    clientEnrollment: "/agent/client-enrollment",
    salesReports: "/sales-reports",
    payReports: "/pay-reports",
    trainingMaterials: "/agent/training-materials",
    complianceMaterials: "/agent/compliance-materials",
    shareInstructions: "/agent/share-instructions",
  },

  // Enrollment endpoints
  enrollment: {
    createSession: "/enrollments/sessions",
    saveStep: "/enrollments/sessions/:sessionId/steps",
    saveStepAuto: "/enrollments/steps/save",
    getSession: "/enrollments/sessions/:sessionId",
    listSessions: "/enrollments/sessions",
    submit: "/enrollments/sessions/:sessionId/submit",
    submitJotForm: "/enrollments/sessions/:sessionId/jotform/submit",
    submitRobloxForm: "/enrollments/robloxform/submit",
    complete: "/enrollments/sessions/:sessionId/complete",
    sendEmailLink: "/enrollments/sessions/:sessionId/send-link",
    moveToPending: "/enrollments/sessions/:sessionId/pending",
    resume: "/enrollments/sessions/:sessionId/resume",
    sendSelfEnrollmentEmail: "/enrollments/self-enrollment/send-email",
    funnelStats: "/enrollments/funnel-stats",
    funnelClients: "/enrollments/funnel-clients",
  },

  // FMO CEO endpoints
  fmo: {
    vendorIntakeLinks: "/fmo/vendor-intake-links",
    assignFormLink: "/fmo/assign-form-link",
    fulfillmentLoadBalancer: "/fmo/fulfillment-load-balancer",
    globalSalesReports: "/fmo/global-sales-reports",
    globalPayReports: "/fmo/global-pay-reports",
  },

  // PFAS endpoints
  pfas: {
    checkZipcode: "/pfas/check-zipcode",
    eligibleZipcodes: "/pfas/eligible-zipcodes",
    validateEligibility: "/pfas/validate-eligibility",
  },

  // HR Manager endpoints
  hr: {
    base: "/hr",
    // Dashboard & Analytics
    dashboardStats: "/hr/dashboard/stats",
    teamPerformance: "/hr/dashboard/team-performance",
    recentActions: "/hr/dashboard/recent-actions",

    // Sales Reports Management
    salesReports: "/hr/sales-reports",
    salesReportsById: "/hr/sales-reports/:id",
    salesReportsStats: "/hr/sales-reports/stats",
    salesReportsByAgent: "/hr/sales-reports/agent/:agentId",
    salesReportsByOrganization: "/hr/sales-reports/organization/:organizationId",

    // Pay Reports Management
    payReports: "/hr/pay-reports",
    payReportsById: "/hr/pay-reports/:id",
    updatePayReport: "/hr/pay-reports/:id",
    payReportsBulkUpdate: "/hr/pay-reports/bulk-update",
    payReportsCorrectAmount: "/hr/pay-reports/:id/correct-amount",
    payReportsSummary: "/hr/pay-reports/summary",
    exportPayReports: "/hr/pay-reports/export",

    // Team & Agent Management
    agents: "/hr/agents",
    agentsById: "/hr/agents/:id",
    teams: "/hr/agent-assignments/teams",
    teamsById: "/hr/teams/:id",
    organizations: "/hr/organizations",
    organizationHierarchy: "/hr/organizations/hierarchy",
    organizationTypes: "/hr/organizations/types",
    organizationsById: "/hr/organizations/:id",
    updateOrganization: "/hr/organizations/:id",
    deleteOrganization: "/hr/organizations/:id",
    bulkReassignAgents: "/hr/organizations/bulk-reassign-agents",
    assignAgentToTeam: "/hr/assign-agent-to-team",
    batchAssignAgents: "/hr/batch-assign-agents",

    // Agent Assignment Management
    agentAssignments: {
      agents: "/hr/agent-assignments/agents",
      teams: "/hr/agent-assignments/teams",
      organizations: "/hr/agent-assignments/organizations",
      assign: "/hr/agent-assignments/assign",
      batchAssign: "/hr/agent-assignments/batch-assign",
    },

    // Geographic and Administrative Data
    states: "/hr/states",
    districts: "/hr/districts",
    organizationsByLevel: "/hr/organizations/level",

    // Intake Link Assignments
    intakeLinkAssignments: "/hr/intake-link-assignments",

    // Load Balancer Configuration
    loadBalancerConfigurations: "/hr/load-balancer-configurations",

    // Organization List ID Management
    organizationListIds: "/hr/organization-list-ids",

    // Agent Status Management
    agentStatus: "/hr/agent-status",
    agentStatusById: "/hr/agent-status/:id",
    updateAgentStatus: "/hr/agents/:id/status",
    activateAgent: "/hr/agents/:id/activate",
    deactivateAgent: "/hr/agents/:id/deactivate",
    terminateAgent: "/hr/agents/:id/terminate",
    reassignAgent: "/hr/reassign-agent",
    agentStatusHistory: "/hr/agents/:id/status-history",

    // Commission & Override Rates
    commissionRates: "/commission-rates",
    commissionRatesById: "/commission-rates/:id",
    commissionRatesStats: "/commission-rates/stats",
    commissionRatesByAgent: "/commission-rates/agent/:agentId",
    commissionRatesByOrganization: "/commission-rates/organization/:organizationId",
    commissionRatesByCampaign: "/commission-rates/campaign/:campaignId",
    commissionRatesByAgentSpecific: "/commission-rates/agent/:organizationId/:campaignId/:agentId",

    // Override Rates
    overrideRates: "/override-rates",
    overrideRatesById: "/override-rates/:id",
    overrideRatesStats: "/override-rates/stats",
    overrideRatesByAgent: "/override-rates/agent/:agentId",
    overrideRatesByOrganization: "/override-rates/organization/:organizationId",
    overrideRatesByCampaign: "/override-rates/campaign/:campaignId",

    // Device Management
    initiateDeviceReregistration: "/hr/initiate-device-reregistration",
    userDevices: "/hr/users/:id/devices",
    deactivateDevice: "/hr/devices/:id/deactivate",
    deviceHistory: "/hr/devices/:id/history",

    // HR Settings & Configuration
    settings: "/hr/settings",
    toggleAgentPayReportView: "/hr/toggle-agent-pay-report-view",

    // Notifications & Workflows
    notifications: "/hr/notifications",
    workflows: "/hr/workflows",
    approvals: "/hr/approvals",

    // Audit & Compliance
    auditLogs: "/hr/audit-logs",
    complianceReports: "/hr/compliance-reports",

    // Bulk Operations
    bulkOperations: "/hr/bulk-operations",
    bulkUpdateAgents: "/hr/bulk-update-agents",
    bulkUpdateRates: "/hr/bulk-update-rates",

    // Campaigns & Products
    campaigns: "/hr/campaigns",
    products: "/hr/products",
    campaignRates: "/hr/campaigns/:id/rates",
  },

  // HR Staff endpoints (Recruit Tracking, Downline Tree, Recruit Management, Granular Deactivation)
  hrStaff: {
    base: "/hr-staff",
    // Recruit Tracking
    recruits: "/hr-staff/recruits",
    // Downline Tree
    organizationTree: "/hr-staff/organization-tree",
    // Recruit Management
    recruitApplication: "/hr-staff/recruits/:recruitId/application",
    recruitApproval: "/hr-staff/recruits/:recruitId/approval",
    // Granular Deactivation Controls
    agentSalesAbility: "/hr-staff/agents/:agentId/sales-ability",
    agentCampaignStatus: "/hr-staff/agents/:agentId/campaign-status",
    agentActiveCampaigns: "/hr-staff/agents/:agentId/active-campaigns",
    agentStatusHistory: "/hr-staff/agents/:agentId/status-history",
    deactivateForCampaign: "/hr-staff/agents/:agentId/campaigns/:campaignId/deactivate",
    reactivateForCampaign: "/hr-staff/agents/:agentId/campaigns/:campaignId/reactivate",
    deactivateWithReason: "/hr-staff/agents/:agentId/deactivate",
    activateWithReason: "/hr-staff/agents/:agentId/activate",
  },
} as const

// Helper function to build endpoint URLs with parameters
export const buildEndpoint = (endpoint: string, params: Record<string, string | number>): string => {
  let url = endpoint
  Object.entries(params).forEach(([key, value]) => {
    url = url.replace(`:${key}`, String(value))
  })
  return url
}

// Type for API endpoints
export type APIEndpoints = typeof API_ENDPOINTS
